import React from "react";
import CodeMirror from '@uiw/react-codemirror';
import { atomone } from "@uiw/codemirror-theme-atomone";


const Editor = ({ language, onChange, value }) => {

    const divStyle = {
        codeBox: {
            overflow: "hidden",
            // overflowY: "scroll",
            textAlign: "start",
            width: "100%",
            height: "calc(100% - 42px)",
            textTransform: "none",
            position: "relative",
        }
    }

    const handleChange = (value) => {
        onChange(value)
    }

    return (
        <div style={divStyle.codeBox} className="setScroll">
            <CodeMirror value={value} style={{ height: "100%" }} extensions={[language()]} theme={atomone} onChange={handleChange} />
        </div>
    );
}

export default Editor;